
if (!customElements.get('ces-2025-live-gallery')) {
  class LifestyleGallery extends HTMLElement {
    constructor() {
      super();
      // this.videoElements = this.querySelectorAll('video');
      // window.addEventListener('scroll', (e) => {
      //   const scrollBottom = window.scrollY + window.innerHeight;
      //   for (const videoElement of this.videoElements) {
      //     if (scrollBottom > this.offsetHeight && videoElement.paused) {
      //       videoElement.play();
      //     }
      //   }
      // });
    }

    createSlider() {
      this.mySwiper = new Swiper(this.querySelector('.swiper'), {
        loop: true,
        centeredSlides: false,
        slidesPerView: 'auto',
        observer: true,
        resizeObserver: true,
        observeParents: true,
        spaceBetween: 16,
      });
    }
  }
  customElements.define('ces-2025-live-gallery', LifestyleGallery);
}

if (!customElements.get('ces-2025-live-gallery-swiper')) {
  class LifestyleGallerySwiper extends HTMLElement {
    constructor() {
      super();

      this.autoplay = this.getAttribute('data-swiper-autoplay') == 'true';
      this.reverseDirection = this.getAttribute('data-swiper-reverse') == 'true';
      this.speed = Number(this.getAttribute('data-swiper-speed'));
      if (isNaN(this.speed)) {
        this.speed = 40000;
      }
      else {
        this.speed = this.speed * 1000;
      }
      this.createSlider();
      window.addEventListener('load',() => {
        this.mySwiper.autoplay.start();
      });
    }

    createSlider() {
      this.mySwiper = new Swiper(this, {
        direction: 'vertical',
        slidesPerView: 'auto',
        loop: true,
        loopAdditionalSlides: 4,
        loopedSlides: 12,
        freeMode: true,
        grabCursor: false,
        allowTouchMove: false,
        autoplay: this.autoplay ? {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true,
        } : false,
        speed: this.speed,
      });
      this.mySwiper.autoplay.stop();
    }
  }
  customElements.define('ces-2025-live-gallery-swiper', LifestyleGallerySwiper);
}